<div class="typo-h8-semibold mb-1 mt-3 font-medium text-primary-blue">{{ title() }}</div>
<div class="flex w-full items-start justify-between gap-2" [formGroup]="contactForm">
  @if (isEditMode()) {
    <lib-input
      type="text"
      class="w-full"
      formControlName="name"
      [placeholder]="namePlaceholder()"
      [state]="validationErrors()?.['nameRequired'] || validationErrors()?.['nameTooLong'] ? 'error' : 'normal'"
      [hint]="nameValidationErrorMessage() ? (nameValidationErrorMessage()! | translate) : null"
      (blur)="onBlur()"
    />
    <lib-input
      type="text"
      class="w-full"
      formControlName="phone"
      libAppPhoneMask
      [placeholder]="phonePlaceholder()"
      [state]="validationErrors()?.['phoneRequired'] ? 'error' : 'normal'"
      [hint]="validationErrors()?.['phoneRequired'] ? ('health_history_patient_secondary_phone_error' | translate) : undefined"
      (blur)="onBlur()"
    />
  } @else {
    <h5
      class="typo-h5-medium truncate text-text-light"
      [class.text-text-primary]="contactForm.controls.name.value"
      [libUiTooltip]="contactForm.controls.name.value ? nameTooltip : undefined"
      tooltipPosition="bottom"
    >
      {{ contactForm.controls.name.value || namePlaceholder() }}
    </h5>
    <h5 class="typo-h5-medium min-w-26 text-text-light" [class.text-text-tertiary]="contactForm.controls.phone.value">
      {{ (contactForm.controls.phone.value ?? undefined | libPhoneFormat) || phonePlaceholder() }}
    </h5>

    <ng-template #nameTooltip>
      <div class="typo-h7-extralight text-text-primary">
        {{ contactForm.controls.name.value }}
      </div>
    </ng-template>
  }
</div>
